import { makeAutoObservable } from "mobx"

class AppStore {
  appLoaded = false
  isResumeJourney = new URL(window.location.href).searchParams.get("applicationState") === "resume"
  windowHeight = window.innerHeight
  windowWidth = window.innerWidth
  device = 1
  ip = ""
  frame_footer = false
  isLocalHost = false
  isTesting = window.location.href.includes("testing")
  visitedQuoteScreen = false
  isProdTesting = new URL(window.location.href).searchParams.get("prodTesting") === "yes" // Can Be Used For A/B Tests.
  appFormLoaded = false // State Updates Only Once To Keep AppForm Mounted Once Its Loaded
  lazyScript = []
  constructor() {
    makeAutoObservable(this)
  }

  setAppLoaded = (data) => (this.appLoaded = data)
  setWindowHeight = (data) => (this.windowHeight = data)
  setWindowWidth = (data) => (this.windowWidth = data)
  setDevice = (data) => (this.device = data)
  setLocalHost = (data) => (this.isLocalHost = data)
  setFrameFooter = (data) => (this.frame_footer = data)
  setIpAddress = (data) => (this.ip = data)
  setIsResumeJourney = (data) => (this.isResumeJourney = data)
  setAppFormLoaded = (data) => (this.appFormLoaded = data)
  setQuoteScreen = (data) => (this.visitedQuoteScreen = data)
  setIsTesting = (data) => (this.isTesting = data)
  setLazyScript = (data) => (this.lazyScript = data)
}

export default new AppStore()
